import type { InjectionKey, Ref } from 'vue';

export const overlaySuspendedKey: InjectionKey<Readonly<Ref<boolean>>> =
  Symbol('overlay-suspended');
